import React from "react";
import "./Header.scss";
import { NavLink, Link } from "react-router-dom";

const Header = (props) => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top border-bottom-0">
      <div className="container-fluid">
        <NavLink to="/" className="navbar-brand" href="#">
          <img
            src="/images/logo/logo-black.png"
            alt="logo"
            className="navbar-logo"
          />
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <div className="mr-auto"></div>
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink
                to="/about"
                className="nav-link"
                aria-current="page"
                href="#"
              >
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/services" className="nav-link" href="#">
                Services
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/process" className="nav-link" href="#">
                Process
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contact-us" className="nav-link" href="#">
                Contact Us
              </NavLink>
            </li>
          </ul>
          <div className="ml-auto d-flex">
            <Link className="btn btn-outline-primary rounded-5 mr-3" to="/login">
              Log in
            </Link>
            <Link className="btn btn-primary rounded-5 ml-3" to="/signup">
              Sign up
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
